import { AccordionItem } from '../Accordion/Accordion'
import Image from '../ui/Image/Image'
import { getImageUrl } from '../../utils'
import DownArrow from '../../assets/images/down-arrow.svg'
import UpArrow from '../../assets/images/up-arrow.svg'

import styles from './Campaign.module.scss'

const CampaignAccordion = ({ tabs, selectedTab, onTabClick, children }) => {
  return (
    <>
      <div className={styles.accordionContainer}>
        <div className={styles.accordion}>
          {tabs?.map((tab) => (
            <AccordionItem
              key={'campaigns' + tab?.countrycode}
              onClick={() => onTabClick(tab)}
              question={
                <div className={styles.accordionContent}>
                  {tab.country_logo && (
                    <Image
                      className={styles.tabIcon}
                      src={getImageUrl(tab.country_logo)}
                      alt={tab?.country_logo?.alternativeText}
                    />
                  )}
                  <span>{tab.country_name}</span>
                </div>
              }
              isOpen={selectedTab?.countrycode === tab?.countrycode}
              collapseIcon={UpArrow}
              expandIcon={DownArrow}
            >
              <div>{children}</div>
            </AccordionItem>
          ))}
        </div>
      </div>
    </>
  )
}

export default CampaignAccordion
